{
  "loading": "正在加载...",
  "placeholder": "选择一个选项..."
}
